<template>
  <div class="searchEncouragementInline">
    <div class="searchEncouragementInline__content">
      <h3 class="searchEncouragementInline__title">Dlaczego ofix?</h3>
      <div class="searchEncouragementInline__items">
        <div v-for="(item, index) in items" :key="index" class="searchEncouragementInline__item">
          <div class="searchEncouragementInline__itemIcon">
            <img
              :src="item.icon.src"
              :alt="item.title"
              :width="item.icon.width"
              :height="item.icon.height"
            />
          </div>
          <div class="searchEncouragementInline__itemContent">
            <div class="searchEncouragementInline__itemTitle">{{ item.title }}</div>
            <div class="searchEncouragementInline__itemDesc" v-html="item.desc" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SearchEncouragementInline',
  computed: {
    ...mapState({
      businessVariables: state => state.settings.businessVariables,
    }),
    items() {
      return [
        {
          icon: {
            width: 54,
            height: 36,
            src: '/tmp/icons/icon-delivery.svg',
          },
          title: 'Darmowa dostawa',
          desc: this?.businessVariables?.freeShipping?.grossFormatted
            ? `Dla zamówień powyżej<br />${this.businessVariables.freeShipping.grossFormatted} zł brutto`
            : 'Dla zamówień powyżej<br />100 zł brutto',
        },
        {
          icon: {
            width: 40,
            height: 50,
            src: '/tmp/icons/icon-platnosci.svg',
          },
          title: 'Bezpieczne płatności',
          desc: 'Płać bez obaw dzięki Przelewy24 i szyfrowaniu SSL',
        },
        {
          icon: {
            width: 55,
            height: 55,
            src: '/tmp/icons/icon-zaufanie.svg',
          },
          title: '99,7% zadowolonych klientów',
          desc: 'Dziękujemy za zaufanie',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.searchEncouragementInline {
  position: relative;
  display: flex;
  width: 100%;
  padding: 3rem 0;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: $cAddLight;
  }

  &__content {
    position: relative;
    width: 100%;
    background-color: $cBg;
    padding: 2.5rem 4.5rem 1rem;

    @include rwd('ultra') {
      padding: 2.5rem 2.5rem 1rem;
    }

    &:before,
    &:after {
      content: '';
      position: absolute;
      height: 100%;
      max-width: 16rem;
      width: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      top: 0;

      @include rwd('tablet') {
        max-width: 10rem;
      }

      @include rwd('small-tablet') {
        max-width: 7rem;
      }
    }

    &:before {
      left: 0;
      background-image: url('/images/search/encouragement-left.svg');
    }

    &:after {
      right: 0;
      background-image: url('/images/search/encouragement-right.svg');
    }
  }

  &__items {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;

    @include rwd('tablet') {
      flex-wrap: wrap;
    }
  }

  &__title {
    position: relative;
    z-index: 1;
    margin-bottom: 3rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    text-align: center;
  }

  &__item {
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    max-width: 31rem;

    @include rwd('tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }

    &:first-child {
      max-width: 27rem;
      @include rwd('tablet') {
        max-width: 100%;
      }
    }
  }

  &__itemIcon {
    flex: 0 0 6rem;
    max-width: 6rem;
    text-align: center;
    margin-right: 1.8rem;
  }

  &__itemTitle {
    margin-bottom: 0.5rem;
    font-size: 1.8rem;
    line-height: 2rem;
    font-weight: 600;

    @include rwd('ultra') {
      font-size: 1.6rem;
      line-height: 1.8rem;
    }
  }

  &__itemDesc {
    font-size: 1.5rem;
    line-height: 1.9rem;

    @include rwd('ultra') {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }
}
</style>
